import React from 'react'
import { Link } from "react-router-dom"

import contactusBanner from "../../assets/contactPageBanner.png";
import contactInfo from "../../assets/contactDetails.png";
import BackBtn from "../../assets/backBtn.png";

import dashedHorizontal from "../../assets/dashedPattern.png"

import "./contactUs.css"

const ContactUs = () => {
  return (

<div className="about-container">
<div className="about-heading">
<Link to={'/'}> <img className="backBtn" src={BackBtn} /></Link>
  <div className="heading-about">CONTACT US</div>
</div>

<div className="about-section">
  <div className="about-left">
    <img src={contactusBanner} className="celebrityImage" />
  </div>

  <div className="about-right">

      <img src={contactInfo} className='aboutAnant-content'/>
  </div>
</div>
<img src={dashedHorizontal} className="dashedHorizontal"/>
</div>
  )
}

export default ContactUs